import { inputDescLimit, inputTextLimit } from '../../../../helpers/fieldRestriction';
import messages from '../../../../locale/jsonMessages';

const validate = (values, props) => {

  const errors = {};
  const activeLanguageCodes = props?.activeLanguageCodes || [];

  if (values.dynamicWhyHostInfoBlock && values.dynamicWhyHostInfoBlock.length > 0) {
    const dynamicWhyHostInfoBlockErrors = [];
    values.dynamicWhyHostInfoBlock.forEach((item, index) => {
      const itemErrors = {};

      const isLanguageInactive = item?.language && activeLanguageCodes.length > 0
        && !activeLanguageCodes.includes(item.language);

      if (!item.language || item.language.toString().trim() === '' || isLanguageInactive) {
        itemErrors.language = messages.required;
      }

      if (!item.workTitleHeading) {
        itemErrors.workTitleHeading = messages.required;
      } else if (item.workTitleHeading.trim() == "") {
        itemErrors.workTitleHeading = messages.required;
      } else if (item.workTitleHeading && item?.workTitleHeading?.length > inputTextLimit) {
        itemErrors.workTitleHeading = messages.inputTextLimitError;
      }

      if (!item.peaceTitle1) {
        itemErrors.peaceTitle1 = messages.required;
      } else if (item.peaceTitle1.trim() == "") {
        itemErrors.peaceTitle1 = messages.required;
      } else if (item.peaceTitle1 && item?.peaceTitle1?.length > inputTextLimit) {
        itemErrors.peaceTitle1 = messages.inputTextLimitError;
      }

      if (!item.peaceTitle2) {
        itemErrors.peaceTitle2 = messages.required;
      } else if (item.peaceTitle2.trim() == "") {
        itemErrors.peaceTitle2 = messages.required;
      } else if (item.peaceTitle2 && item?.peaceTitle2?.length > inputTextLimit) {
        itemErrors.peaceTitle2 = messages.inputTextLimitError;
      }

      if (!item.peaceContent1) {
        itemErrors.peaceContent1 = messages.required;
      } else if (item.peaceContent1.trim() == "") {
        itemErrors.peaceContent1 = messages.required;
      } else if (item.peaceContent1 && item?.peaceContent1?.length > inputDescLimit) {
        itemErrors.peaceContent1 = messages.inputDescLimitError;
      }

      if (!item.peaceContent2) {
        itemErrors.peaceContent2 = messages.required;
      } else if (item.peaceContent2.trim() == "") {
        itemErrors.peaceContent2 = messages.required;
      } else if (item.peaceContent2 && item?.peaceContent2?.length > inputDescLimit) {
        itemErrors.peaceContent2 = messages.inputDescLimitError;
      }

      if (Object.keys(itemErrors).length > 0) {
        dynamicWhyHostInfoBlockErrors[index] = itemErrors;
      }
    });

    if (dynamicWhyHostInfoBlockErrors.length > 0) {
      errors.dynamicWhyHostInfoBlock = dynamicWhyHostInfoBlockErrors;
    }
  }

  return errors
}

export default validate;